const floatingActionsRoot = document.querySelector('[data-floating-actions]');

if (floatingActionsRoot) {
  const scrollButton = floatingActionsRoot.querySelector(
    '[data-scroll-to-top]'
  );
  const whatsappLink = floatingActionsRoot.querySelector(
    '[data-whatsapp-link]'
  );
  const respectReducedMotion =
    floatingActionsRoot.dataset.respectReducedMotion === 'true';
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  const reduceMotion = respectReducedMotion && prefersReducedMotion;
  const gsap = typeof window.gsap !== 'undefined' ? window.gsap : null;
  const animateButtons = !!gsap && !reduceMotion;

  if (whatsappLink instanceof HTMLAnchorElement) {
    const rawNumber = whatsappLink.dataset.whatsappNumber ?? '';
    const sanitizedNumber = rawNumber.replace(/\D/g, '');

    if (sanitizedNumber) {
      whatsappLink.href = `https://wa.me/${sanitizedNumber}`;

      if (animateButtons) {
        gsap.set(whatsappLink, { autoAlpha: 0, y: 10 });
        gsap.to(whatsappLink, {
          autoAlpha: 1,
          y: 0,
          duration: 0.45,
          ease: 'power3.out',
          delay: 0.15,
        });
        gsap.to(whatsappLink, {
          y: -4,
          duration: 1.5,
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut',
          delay: 0.65,
        });
      }
    } else {
      whatsappLink.remove();
    }
  }

  if (scrollButton instanceof HTMLButtonElement) {
    const scrollThreshold = 320;
    const scrollBehavior = reduceMotion ? 'auto' : 'smooth';

    if (animateButtons) {
      gsap.set(scrollButton, { autoAlpha: 0, y: 14 });
      scrollButton.hidden = true;
    }

    const toggleScrollButton = () => {
      const shouldShow = window.scrollY > scrollThreshold;
      scrollButton.classList.toggle('is-visible', shouldShow);

      if (animateButtons) {
        if (shouldShow) {
          scrollButton.hidden = false;
          gsap.killTweensOf(scrollButton);
          gsap.to(scrollButton, {
            autoAlpha: 1,
            y: 0,
            duration: 0.35,
            ease: 'power3.out',
          });
        } else {
          gsap.killTweensOf(scrollButton);
          gsap.to(scrollButton, {
            autoAlpha: 0,
            y: 14,
            duration: 0.22,
            ease: 'power3.in',
            onComplete: () => {
              scrollButton.hidden = true;
            },
          });
        }
      } else {
        scrollButton.hidden = !shouldShow;
      }
    };

    scrollButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: scrollBehavior });
    });

    window.addEventListener('scroll', toggleScrollButton, { passive: true });
    toggleScrollButton();
  }

  if (!floatingActionsRoot.children.length) {
    floatingActionsRoot.remove();
  }
}
